import styled from 'styled-components';
import Text from '@components/common/Text';
import Icon from '@src/svg/Icon';
import { colorCode } from '@styles/styleUtils';

const FullSizeBarcodeWrap = styled.button`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
`;

interface Props {
  onClick?: () => void;
}

const FullSizeBarcodeButton = ({ onClick }: Props): JSX.Element => {
  return (
    <FullSizeBarcodeWrap onClick={onClick}>
      <Icon
        name="circle-plus"
        width={16}
        height={16}
        color={colorCode('gray40')}
      />
      <Text typo="body3_medium" color="gray40">
        크게보기
      </Text>
    </FullSizeBarcodeWrap>
  );
};

export default FullSizeBarcodeButton;
